//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from 'react';
import context from 'context/context';
import { useHistory, useLocation } from 'react-router-dom';
import * as moment from 'moment';
import { useTranslation } from 'react-i18next';
import { toast } from "react-toastify";
import { CSVLink } from 'react-csv';
import { exportHeaders } from './export';
import InputAdornment from "@material-ui/core/InputAdornment";
import MenuItem from "@material-ui/core/MenuItem";


// custom pages
import Table from 'components/Table/Table';
import promotion from 'apis/promotion/promotion';
import { styles } from './styles';
import Loader from 'components/Loader/Loader';
import VisibilityIcon from '@material-ui/icons/Visibility';
import useDebounce from "helpers/useDebounce";

//access
import access from 'config/access';

// material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import TextField from "@material-ui/core/TextField";
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import Box from '@material-ui/core/Box';

// material-ui icons
import Grid from "@material-ui/core/Grid";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { withStyles } from "@material-ui/core/styles";
import searchIcon from "assets/img/Search_Icon.png";
import banner from 'apis/banner/banner';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import editIcon from 'assets/img/editIcon.png';




//Helpers
import { dateFormat } from "helpers/dataFormat";
const CssTextField = withStyles({
  root: {
      '& label.Mui-focused': {
          color: '##D3D3D3',
      },
      '& .MuiFormLabel-root': {
          color: '#707070',
      },
      '& .MuiInputBase-input': {
          color: '#707070',
      },
      '& .MuiInput-underline:before': {
          borderBottomColor: '#707070!important',
      },
      '& .MuiInput-underline:after': {
          borderBottomColor: '#707070!important',
      },
      '& .MuiOutlinedInput-root': {
          '& fieldset': {
              borderColor: '#707070',
          },
          '&:hover fieldset': {
              borderColor: '#707070',
          },
          '&.Mui-focused fieldset': {
              borderColor: '#707070',
          },
          '&.MuiOutlinedInput-root': {
              borderRadius: 20,
          },
          '&.MuiOutlinedInput-root': {
              marginTop: 0,
              borderRadius: 20,
              background: '#ededed',
              marginTop: -11,
              display : 'flex',
              marginLeft :30,
              marginRight:10
          },
      },
  },
})(TextField);


export default function TargetAccounts(props) {
  const { state, dispatch } = useContext(context);
  const { getTargetAccounts, exportAPI, searchTargetAccounts,updateTargetAccountsSingle} = banner();
  const history = useHistory();
  const location = useLocation();
  const classes = styles();
  const [data, setData] = useState([]);
  const [promotionData, setPromotionData] = useState({});
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [res, setRes] = useState(false);
  const { t, i18n } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [exportData, setExportData] = useState([])
  const [searchValue, setSearchValue] = useState("");
  const searchBounceValues = useDebounce(searchValue);
  const [value, setValue] = React.useState(0);

  const [editObj, setEditObj] = useState({
    id: '',
    is_active: '',
    type: 'UPDATE'
});


  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: 'SET_PATHNAME',
      payload: ['HOME', 'ADMIN', 'Promotion Management', 'Criteria'],
    });
   
  }, []);

  // change pagination func
  const handlePagination = (value) => {
    console.log(value,'this is the paginationvalues')
    setOffset(value);
  };

  useEffect(() => {
    if (location?.state?.data) {
      setPromotionData(location?.state?.data);
    }
  });

  // handling api calls
  useEffect(() => {
    if (location?.state?.id) {
      handleGet();
    }
  }, [offset]);

  // get api func
  const handleGet = async () => {
    try {
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
        targetBannerId: location?.state?.id,
      };
      let res = await getTargetAccounts(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setRes(true);
      }
    } catch (e) {
      console.log({ e });
    }
  };
  async function handleUpdate() {
    try {
        dispatch({ type: "SET_LOADING", payload: true });
        let obj = { ...editObj, type: 'UPDATE' }
         setEditObj({...editObj,type:'UPDATE'})
         console.log('update',obj)

         let res = await updateTargetAccountsSingle(obj);
    
        if (res.type == 'success') {
         
            toast.success('Updated Successfully...')
            setEditObj({})
            handleGet()
        } else {
            setLoading(false)
            dispatch({ type: "SET_LOADING", payload: false });
            toast.error(res.message)
            handleGet()
        }
    } catch (e) {
        console.log({ e });
    }
}

  async function handleExport() {
    try {
      setLoading(true)
      let values = {
        searchValue: searchValue,
        targetBannerId: location?.state?.id,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await exportAPI(values);
      if (res) {
   
        setExportData(res.data.map(obj => {
          return {
            ...obj,
            category_value: obj?.category_value + String.fromCharCode(8203),
          }
        }));
        setLoading(false)
        dispatch({ type: "SET_LOADING", payload: false });
        return true
      }
      setLoading(false)
      return false
    }
    catch (err) {
      console.log({ err });
      setLoading(false)

      return false
    }
  }

  async function handleSearch() {
    try {
      // setLoading(true);
      let values;
      values = {
        searchValue: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,

       
        
      };
     
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await searchTargetAccounts(values);
      dispatch({ type: "SET_LOADING", payload: false });
      
      if (res) {
        setData(res.data);
        setCount(res.count);
        return;
        // setLoading(false);
       
      }
      setData([]);
    }
    catch (e) {
      console.log({ e });
    }
  }

  useEffect(() => {
    searchValue && searchValue.length > 0 ? handleSearch() : handleGet();
  }, [offset]);

  // // handling search api
  useEffect(() => {
    if (searchBounceValues && searchBounceValues.length > 0) {
      handleSearch();
    } else {
      setOffset(1);
    }
  }, [searchBounceValues])

 

  

  return (
    <React.Fragment>
      <Grid container className={classes.root}>
        <Grid xs={12} sm={6} lg={6} >
       
          <IconButton
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowBackIcon style={{ color: '#305698' }} />
          </IconButton>
          
      


        </Grid>
        <Grid xs={12} sm={6} lg={6} style={{ textAlign: 'end', paddingTop: '10px' }}>
        
        <CssTextField
            placeholder="Search for Target Accounts"
            type={"text"}
            variant="outlined"
            // onKeyDown={blockInvalidCharForText}
            className={classes.searchInput}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {searchValue.length > 0 ? (
                    <CloseOutlinedIcon
                      className={classes.searchInputIcon}
                      onClick={() => {
                        setSearchValue("");
                        setOffset(1);
                        handleGet();
                      }}
                    />
                  ) : (
                    <img
                      src={searchIcon}
                      alt=""
                      width="20px"
                      className={classes.searchInputIcon}
                    />
                  )}
                </InputAdornment>
              ),
            }}
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
              setOffset(1);
              if (e.target.value.length == 0) {
                handleGet();
              }
            }}
            onClick={() => {
              setOffset(offset);
            }}
          />
          <CSVLink
            id="csv"
            data={exportData.map(item => ({
              ...item,
              is_active : item.is_active ? "Active" :"Inactive"

            }))}


            headers={exportHeaders.map((head) => head)}
            filename={
              `Target Accounts` + moment(new Date()).format("MM-DD-YYYY,h:mm A") + ".csv"
            }
            className={classes.CSVlink}
          />
          <button
            disabled={loading}
            className={classes.exportBtn}
            onClick={async () => {
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}
          >
            {loading ? (
              <div class="snippet" style={{ marginLeft: 55 }}>
                <div class="stage">
                  <div class="dot-typing-e"></div>
                </div>
              </div>
            ) :
              `Export`
            }
          </button>
        </Grid>
      </Grid>

      <Grid className={classes.tableDownInResponsive}>
        <Grid xs={12} sm={12} lg={12}>
          {res ? (
            <Table
              headings={[
                'S.No',
                'Target Accounts',
                'Target Type',
                'Status',
                ""
              ]}
              data={
                data &&
                data.map((d, i) => [
                  (offset - 1) * 10 + i + 1,
                  d?.target_account ,
                  d?.target_type ,
                  editObj?.id == d?.id ?
                                <TextField
                                    select
                                    value={editObj?.is_active}
                                    onChange={e => setEditObj({ ...editObj, is_active: e.target.value })}
                                    style={{ width: "100%" }}
                                >
                                    <MenuItem value={true}>Target</MenuItem>
                                    <MenuItem value={false}>Target Removed</MenuItem>
                                </TextField> :
                                [d?.is_active == true ?
                                    <span style={{ color: "green" }}>Target</span> :
                                    <span style={{ color: "red" }}>Target Removed</span>
                                ], ,
                  [
                    editObj.id == d?.id ? (
                        <React.Fragment>
                            <CheckCircleOutlineIcon
                                style={{
                                    cursor: 'pointer',
                                    color: 'green',
                                    margin: '0px 5px',
                                    fontSize: 35,
                                }}
                                onClick={() => {
                                    if (editObj.is_active === d?.is_active) {
                                        toast.success("change any field");
                                        return;

                                    }
                                    console.log('edit clicked',editObj.is_active,d?.is_active)

                                    handleUpdate();
                                }}
                            />
                            <HighlightOffIcon
                                style={{
                                    cursor: 'pointer',
                                    color: 'red',
                                    margin: '0px 5px',
                                    fontSize: 35,
                                }}
                                onClick={() => {

                                    setEditObj({});

                                }}
                            />
                        </React.Fragment>
                    ) : (
                        (
                            <div
                                style={{ cursor: 'pointer' }}

                                onClick={() => {

                                    setEditObj({ ...editObj, id: d?.id, is_active: d?.is_active })



                                    return;
                                }
                                }
                            >
                                <img src={editIcon} alt='' width='20' />
                            </div>
                        )
                    ),
                ]

                  
                ])
              }
              offset={offset}
              count={
                (count / 10) % 1 == 0
                  ? Math.floor(count / 10)
                  : Math.floor(count / 10 + 1)
              }
              handlePagination={handlePagination}
            />
          ) : (
            <Loader Loading={true} top={'15%'} />
          )}
        </Grid>
      </Grid>
    </React.Fragment>
  );
}